import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EncryptionService } from '@shared/services/encryption.service';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { PostCartDto, PostCartResp } from '@usecase/cart/cart.interface';
import { CheckoutRepository } from '@data/repositories/checkout.repository';
import { OrderData } from '@data/domain/checkout.entity';
import { CreateOrderAffiliateDto, CreateOrderAffiliateResp } from '@usecase/checkout/create-order-btl/create-order-affiliate.interface';
import { CreateOrderPackageDto } from '@usecase/checkout/create-order-package/create-order-package.interface';
import { HttpService } from '@shared/service.http';
import { CreateOrderRoamingDto, CreateOrderRoamingResp } from '@usecase/checkout/create-order-roaming/create-order-roaming.type';
import { CheckoutDetailDto, CheckoutDetailResp } from '@usecase/checkout/checkout-detail/checkout-detail.type';

@Injectable({
    providedIn: 'root'
})

export class CheckoutAdapter extends CheckoutRepository {
    private readonly httpService = inject(HttpService);
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly encryptionService = inject(EncryptionService);

    private addHeaders(): Array<{ key: string; value: string }> {
      let header: { key: string, value: string }[] = [];
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params) {
          const encryptionParam = this.encryptionService.newEncryptData(JSON.stringify(params));
          header = [
            {
              key: 'x-url-payload',
              value: encryptionParam
            }
          ];
        }
      });
      return header;
    }

    CreateOrderPackage(params: CreateOrderPackageDto): Observable<OrderData> {
        return this.httpService.post(`${environment.serviceApi}order-telco`, params);
    }

    GetCheckoutDetail(params: CheckoutDetailDto): Observable<CheckoutDetailResp> {
        return this.httpService.get(`${environment.serviceApi}order-telco/${params.orderId}`, {});
    }

    CreateOrderAffiliate(params: CreateOrderAffiliateDto): Observable<CreateOrderAffiliateResp> {
        const headers = this.addHeaders();
        return this.httpService.post(`${environment.serviceApi}v1/order/btl`, params, headers);
    }

    PostCart(payload: PostCartDto): Observable<PostCartResp> {
        return this.httpService.post(`${environment.serviceApi}cart/point/insert`, payload);
    }
    CreateOrderRoaming(payload: CreateOrderRoamingDto): Observable<CreateOrderRoamingResp> {
        return this.httpService.post(`${environment.serviceApi}activation-roaming`, payload);
    }
}
